var _Circle, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgSuccessLock = function SvgSuccessLock(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#37CC33"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.039 11.558V8.817a4.112 4.112 0 1 1 8.223 0v2.741h1.37c.757 0 1.37.614 1.37 1.37v8.224a1.37 1.37 0 0 1-1.37 1.37H9.667a1.37 1.37 0 0 1-1.37-1.37V12.93c0-.757.614-1.37 1.37-1.37h1.372Zm6.168 0h-4.112V8.817a2.056 2.056 0 0 1 4.112 0v2.741Zm.686 5.482a2.741 2.741 0 1 0-5.482 0 2.741 2.741 0 0 0 5.482 0Zm-1.372 0a1.37 1.37 0 1 1-2.741 0 1.37 1.37 0 0 1 2.741 0Z",
    fill: "white"
  })));
};
export default SvgSuccessLock;